<template>
    <div id='footer2'>
        <div class="type_area footer2">
            Copyright  2019 ONiLAB LLC Scientific Inc.
        </div>
    </div>
</template>
<script>
export default {

}
</script>
<style scoped lang="less">
    #footer2{
        width:100%;
        height:3rem;
        background:#257CE1;
        // position: fixed;
        // bottom: 0;
        z-index: 9999;
        .footer2{
            height:100%;
            display:flex;
            justify-content: center;
            align-items:center;
            font-size: 0.8rem;
        }
    }
</style>